import { useEffect, useRef, useState } from 'react';

const useEllipsisDetection = () => {
  const ref = useRef<HTMLElement>(null);
  const [hasEllipsis, setHasEllipsis] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const checkEllipsis = () => {
      const isTruncated = element.scrollWidth > element.clientWidth + 1;
      setHasEllipsis(isTruncated);
    };

    checkEllipsis();
    window.addEventListener('resize', checkEllipsis);

    return () => window.removeEventListener('resize', checkEllipsis);
  }, []);

  return { ref, hasEllipsis };
};

export default useEllipsisDetection;
